"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_PATCHED_MODULE = void 0;
exports.IS_PATCHED_MODULE = Symbol('isPatchedModule');